import { render } from "./KpiCards.vue?vue&type=template&id=79904b20&scoped=true"
import script from "./KpiCards.vue?vue&type=script&lang=js"
export * from "./KpiCards.vue?vue&type=script&lang=js"

import "./KpiCards.vue?vue&type=style&index=0&id=79904b20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79904b20"]])

export default __exports__